import { useState } from "react";
import { Button } from "@design-system/Button/Button";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { CommandPalette } from "@design-system/CommandPalette/CommandPalette";
import { Command } from "@vendor/cmdk/cmdk";
import { BooleanControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./OverlayPlayground.module.scss";

const navigationCommands = [
    {
        value: "transactions",
        label: "Go to transactions",
        shortcut: "g>t",
    },
    { value: "tasks", label: "Go to tasks", shortcut: "g>k" },
    { value: "reports", label: "Go to reports" },
];

const accountCommands = [
    { value: "connect-bank", label: "Connect a bank account" },
    { value: "connect-card", label: "Connect a card" },
];

export const CommandPalettePlayground = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [search, setSearch] = useState("");
    const [hasBreadcrumbs, setHasBreadcrumbs] = useState(false);
    const [hasFooter, setHasFooter] = useState(false);
    const [isEmpty, setIsEmpty] = useState(false);

    return (
        <SandboxLayout
            controls={
                <section>
                    <h2>Slots</h2>
                    <div className={styles.controls}>
                        <BooleanControl
                            label="Breadcrumbs"
                            checked={hasBreadcrumbs}
                            onChange={setHasBreadcrumbs}
                        />
                        <BooleanControl
                            label="Footer"
                            checked={hasFooter}
                            onChange={setHasFooter}
                        />
                        <BooleanControl
                            label="No commands"
                            checked={isEmpty}
                            onChange={setIsEmpty}
                        />
                    </div>
                </section>
            }
        >
            <ShowcasePreview
                summary={isOpen ? "open" : "closed"}
                output={JSON.stringify(
                    {
                        show: isOpen,
                        search,
                        slots: { hasBreadcrumbs, hasFooter },
                    },
                    null,
                    2,
                )}
            >
                <Button
                    variant="primary"
                    size="md"
                    onClick={() => setIsOpen(true)}
                >
                    Open command palette
                </Button>
                <CommandPalette
                    show={isOpen}
                    onHide={() => setIsOpen(false)}
                    search={search}
                    onSearchChange={setSearch}
                    breadcrumbs={
                        hasBreadcrumbs ? (
                            <aside>Workspace settings</aside>
                        ) : null
                    }
                    footer={
                        hasFooter ? (
                            <Command.Group heading="Accounts">
                                {accountCommands.map((command) => (
                                    <CommandItem
                                        key={command.value}
                                        value={command.value}
                                        onSelect={() => setIsOpen(false)}
                                    >
                                        {command.label}
                                    </CommandItem>
                                ))}
                            </Command.Group>
                        ) : null
                    }
                >
                    {isEmpty ? null : (
                        <Command.Group heading="Navigation">
                            {navigationCommands.map((command) => (
                                <CommandItem
                                    key={command.value}
                                    value={command.value}
                                    shortcut={command.shortcut}
                                    onSelect={() => setIsOpen(false)}
                                >
                                    {command.label}
                                </CommandItem>
                            ))}
                        </Command.Group>
                    )}
                </CommandPalette>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
